import { ArrowDown, ArrowUp } from 'lucide-react';

import type { GiftPassListRow, GiftPassSortOrder } from '../../api/gift-passes';

import { GiftPassesTableRow } from './GiftPassesTableRow';

export interface GiftPassesTableProps {
  rows: GiftPassListRow[];
  order: GiftPassSortOrder;
  onOrderChange: (order: GiftPassSortOrder) => void;
}

/** Only the created date sorts; staff find a pass by searching. */
export function GiftPassesTable({ rows, order, onOrderChange }: GiftPassesTableProps) {
  const Arrow = order === 'desc' ? ArrowDown : ArrowUp;
  return (
    <table className="nb-tbl" aria-label="Gift passes" style={{ minWidth: 860 }}>
      <thead>
        <tr>
          <th scope="col" style={{ paddingLeft: 18 }}>
            Pass
          </th>
          <th scope="col">Purchaser</th>
          <th scope="col">Recipient</th>
          <th scope="col">Origin</th>
          <th scope="col">Status</th>
          <th
            scope="col"
            aria-sort={order === 'desc' ? 'descending' : 'ascending'}
            style={{ paddingRight: 18 }}
          >
            <button
              type="button"
              className="nb-btn nb-btn-ghost"
              onClick={() => onOrderChange(order === 'desc' ? 'asc' : 'desc')}
              style={{
                height: 24,
                padding: '0 4px',
                font: 'inherit',
                color: 'inherit',
                textTransform: 'inherit',
                gap: 4,
              }}
            >
              Created
              <Arrow size={12} aria-hidden />
            </button>
          </th>
        </tr>
      </thead>
      <tbody>
        {rows.map((row) => (
          <GiftPassesTableRow key={row.id} row={row} />
        ))}
      </tbody>
    </table>
  );
}
